import React from 'react';
import {Col, Row}from 'react-bootstrap';

const DetailField = ({label, xs = 12, sm = 6, md = 6, lg = 3, labelClassName = '', valueClassName = '', children}) => {
    return (
        <Row>
            <Col xs={xs} sm={sm} md={md} lg={lg} className={labelClassName}>{label}:</Col>
            <Col xs={xs} sm={sm} md={md} lg={lg} className={valueClassName}>{children}</Col>
        </Row>
    )
};

export default DetailField;


// WEBPACK FOOTER //
// ./src/components/common/detail-field.jsx